module.exports = __webpack_public_path__ + "static/img/introduceBTypeBIcon2.1eac64a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeBIcon2.png
// module id = dyLN
// module chunks = 0